export default __webpack_public_path__ + "static/media/laptop-1.6c0fca97.gif";